import styled from "styled-components";
import { Section, MainTitle, Paragraf } from "../Styled";

export const HeroSection = styled.div`
min-height: 100vh;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: linear-gradient(
    132deg,
    rgb(0, 48, 143) 0%,
    rgb(1, 180, 180) 100%
  );
`

export const HeroInner = styled(Section)`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
row-gap: 50px;
@media screen and (max-width: 1000px) {
   flex-direction: column;
   align-items: space-evenly;
}
`
export const HeroLeft = styled.div`
width: 50%;
display: flex;
flex-direction: column;
row-gap: 10px;
 & ${MainTitle} {
    margin: 0;
    color: ${({ theme }) => theme.mainColors.hvid};
    @media screen and (max-width: 600px) {
      font-size: 2rem;
   }
 }
 & ${Paragraf} {
    margin: 0;
    color: ${({ theme }) => theme.mainColors.hvid}
 }
 @media screen and (max-width: 1000px) {
   width: 100%;
}
`
export const AppVideo = styled.video`
width: 200px;
height: 432px;
border-radius: 20px;
border: 3px solid black;
box-shadow: 0 10px 30px rgb(0 0 29 / 100%);
`